module.exports = __webpack_public_path__ + "static/media/School_closing_delay.80d4d002.svg";